import "./tabs.css.ts.vanilla.mjs";
var _ = "p273__tabs-ad55_fc7cdc54a__v4yaqf1", c = "p273__tabs-ad55_fc7cdc54a__v4yaqf0", t = "p273__tabs-ad55_fc7cdc54a__v4yaqf2";
export {
  _ as darkTheme,
  c as lightTheme,
  t as tabsStyle
};
//# sourceMappingURL=tabs.mjs.map
